
import Vue from 'vue'
import RCheckbox from '@/components/forms/RCheckbox.vue'

const rootPath = 'https://storage.googleapis.com/renderro-mvp.appspot.com/legal/'

export default Vue.extend({
  components: {
    RCheckbox,
  },
  name: 'GDPRCheckbox',
  // this is how we customize the component's
  // v-model behavior so that the parent's value
  // goes to the 'checked' prop
  model: {
    prop: 'checked',
    event: 'change',
  },
  props: {
    checked: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    getFilePath(file: File): string {
      return rootPath + file
    },
  },
})
